var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpoweridAppLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.804 0H4.01C1.795 0 0 1.74 0 3.885v11.43C0 17.461 1.795 19.2 4.009 19.2h11.795c2.214 0 4.01-1.74 4.01-3.885V3.885c0-2.146-1.796-3.885-4.01-3.885h0z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.537.1v8.229h2.768c2.695 0 4.308-1.53 4.308-4.115S9 .1 6.305.1H3.537z",
    transform: "translate(1 1) translate(4.65 5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0.5 0L0.5 8.4",
    transform: "translate(1 1) translate(4.65 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpoweridAppLogo);
export default __webpack_public_path__ + "static/media/empowerid-app-logo.785680ee219a280a24a0c1b06c954a50.svg";
export { ForwardRef as ReactComponent };